<template>
    <!-- 开发登录 -->
    <div class="dev-login">
        <van-field label="医助编码：" v-model="form.refUserNo" />
        <van-field label="Token：" v-model="form.userSessionStr" />
        <van-button type="info" style="margin-top: 15px; width: 100%" @click="onSubmit">登录</van-button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                refUserNo: '',
                userSessionStr: ''
            }
        }
    },
    methods: {
        onSubmit() {
            if (!this.form.refUserNo) {
                this.$toast('请输入医助编码')
                return false;
            } else if (!this.form.userSessionStr) {
                this.$toast('请输入Token')
                return false;
            }
            this.$store.dispatch('setAssistantNo', this.form.refUserNo);
            sessionStorage.setItem('userToken', this.form.userSessionStr);
            this.$router.replace('/')
        }
    }
}
</script>
<style lang="scss" scoped></style>